export enum PageLayoutEnum {
  RIGHT_SECTION = 'right-section',
  LEFT_SECTION = 'left-section'
}
